import { render, staticRenderFns } from "./ProjectExternalLayouts.vue?vue&type=template&id=61b0d444"
import script from "./ProjectExternalLayouts.vue?vue&type=script&lang=js"
export * from "./ProjectExternalLayouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports